import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=157d8bed&"
import script from "./nothing.vue?vue&type=script&lang=js&"
export * from "./nothing.vue?vue&type=script&lang=js&"
import style0 from "./nothing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports